module.exports = __webpack_public_path__ + "static/media/contact_telephone.343fc494.svg";